import { useEffect, useState } from 'react'
import type { BoxProps } from '@mantine/core'
import { Box } from '@mantine/core'

import { Text } from '@/components/Text/Text'

import { TRANSACTION_NOTICE_KEY } from '@/constants/localStorageKeys.constants'

import classes from './TransactionSyncNotice.module.css'

export function TransactionSyncNotice({ ...props }: BoxProps) {
  const [isExpired, setIsExpired] = useState(true)

  useEffect(() => {
    const storedData = localStorage.getItem(TRANSACTION_NOTICE_KEY)

    if (!storedData) return

    const now = Date.now()
    const expireDate = parseInt(storedData, 10)

    if (now < expireDate) {
      setIsExpired(false)
    }
  }, [])

  if (isExpired) return null

  return (
    <Box className={classes.notice} {...props}>
      <Text variant="body_3">
        You added a new account. Transactions are being synced. The changes
        might show up in a moment.
      </Text>
    </Box>
  )
}
